import { updateSettingsState } from 'common/settings/actions'

import adminsReducer from './admins'

const initialState = {
  fetching: false,
  error: null,
  ready: false,
  items: [],
}

export default function botSettingsReducer(state = initialState, action) {
  state = { ...state, admins: adminsReducer(state.admins, action) }

  switch (action.type) {
    case updateSettingsState.type: {
      return { ...state, fetching: false, ready: false }
    }
  }

  return state
}
